import {
	type AnyFieldApi,
	createFormHook,
	createFormHookContexts,
} from "@tanstack/react-form";

import {
	Autocomplete,
	DatePicker,
	DateRangePicker,
	FilePicker,
	Input,
	NumberInput,
	Select,
	SelectMultiple,
	TextArea,
} from "@onesolution/components";

export const { fieldContext, formContext, useFieldContext } =
	createFormHookContexts();

export const { useAppForm } = createFormHook({
	fieldContext,
	formContext,
	fieldComponents: {
		Input,
		DatePicker,
		DateRangePicker,
		TextArea,
		Select,
		SelectMultiple,
		Autocomplete,
		NumberInput,
		FilePicker,
	},
	formComponents: {},
});

export type AppFormApi = ReturnType<typeof useAppForm>;

export type AppFormFieldApi = AnyFieldApi & {
	Input: typeof Input;
	DatePicker: typeof DatePicker;
	DateRangePicker: typeof DateRangePicker;
	TextArea: typeof TextArea;
	Select: typeof Select;
	SelectMultiple: typeof SelectMultiple;
	Autocomplete: typeof Autocomplete;
	NumberInput: typeof NumberInput;
	FilePicker: typeof FilePicker;
};
